import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Spinner } from '@/components/spinner';
import { useAppContext } from '@/context/app';
import { MachinesReportWizardStep1 } from './Step1';
import { cleanWizardData, WizardData } from './Model';
import { useWizard, WizardProvider } from '@/common/wizard/wizard';
import { UseFormReturn } from 'react-hook-form';
import { addServerErrors } from '@/components/forms/common/FormBase';
import { MachinesReportWizardResult } from './Result';

const maxStep = 2

export const MachinesReportWizardBody = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  // const {services, session, translates} = useAppContext()
  const { step} = useWizard()

  if (step === 0) {
    return <MachinesReportWizardStep1  />
  } else if (step === 1) {
    return <MachinesReportWizardResult />
  } else return <Spinner />
}

export const MachinesReportWizard = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  return <div className='machinesranking-wizard'>
    <WizardProvider<WizardData> initialData={cleanWizardData()} maxStep={maxStep}>
      <MachinesReportWizardBody onDone={onDone} />
    </WizardProvider>
  </div>
}

export const MachinesReportWizardPopup = ({ onClose }: {
  onClose: () => void
}) => {
  return <MachinesReportWizard onDone={onClose} />
}
